import React, {Component} from "react";
import PropTypes from "prop-types";

import {cloneDeep, remove} from "lodash";

import {
    Input,
    Spinner,
    Dropdown,
    DropdownMenu,
} from "reactstrap";
//classes
import WbSession from "classes/Session.jsx";

class BusinessField extends Component {
    static contextType = WbSession;
    
    debug = false;
    state = {
        currentValue: '',
        lastLookup: '',
        searchResults: [],
        hasMore: false,
        hasFocus: false
    };
    fieldTimeout = {};
    blurTimeout = {};
    
    constructor( props ){
        super( props );
        this.state.currentValue = this.props.value ?? '';
    }
    
    lookup_abr = async () => {
        const { currentValue, lastLookup } = this.state;
        
        const lookup = currentValue.trim();
        
        if( lookup.length > 5 && lastLookup != lookup ){
            this.setState({loadingAbn:true,searchResults:[]});
            const data = await this.context.lookupBusiness( lookup );
            
            if( data.success && typeof data.entity_data != "undefined" ){
                let results = data.entity_data.searchResultsRecord ?? [];
                if( typeof results[Symbol.iterator] !== 'function' ){ // if is not an iterable array (ie. only one result)
                    results = [ results ]; // add this result into an array
                }
                this.setState({
                    loadingAbn: false,
                    lastLookup: lookup,
                    searchResults: results,
                    hasMore: ('Y'==data.entity_data.exceedsMaximum),
                });
            } else {
                this.setState({
                    loadingAbn: false,
                    lastLookup: '',
                    searchResults: [],
                    hasMore: false,
                });
            }
        } else {
            this.setState({
                loadingAbn: false,
                lastLookup: '',
                searchResults: [],
                hasMore: false,
            });
        }
    };
    
    formatAbn = ( newAbn ) => {
        const inputStr = newAbn.replaceAll(" ","").trim();
        let newStr = " ";
        let len = inputStr.length;
        for (let i = 0; i<len; i++) {
            newStr = newStr + inputStr[i];
            if( // Add spaces to format xx xxx xxx xxx
                3 == newStr.length ||
                7 == newStr.length ||
                11 == newStr.length
            ) {
                newStr = newStr + " ";
            }
        }
        
        newStr = newStr.trim();
        
        if( newStr.length > 14 ){ // 11 digits, plus 3 spaces
            newStr = newStr.substring(0, 14);
        }
        
        return newStr;
    };
    
    render(){
        const {
            fldId,
            value,
            placeholder,
            onChange,
            error,
            readonly,
        } = this.props;
        
        const {
            loadingAbn,
            searchResults,
            hasMore,
            hasFocus,
        } = this.state;
        
        let fldClass = '';
        if( readonly ){
            fldClass += ' form-control-muted';
        }
        
        return (
            <>
                <Dropdown
                    direction="down"
                    isOpen={hasFocus&&(searchResults.length||loadingAbn)}
                    className="abnField"
                    onFocus={e=>{
                        clearTimeout(this.blurTimeout);
                        this.setState({hasFocus:true});
                    }}
                    onBlur={e=>{
                        clearTimeout(this.blurTimeout);
                        this.blurTimeout = setTimeout( e=>{
                            this.setState({hasFocus:false});
                        }, 600 );
                    }}
                >
                    <Input
                        id={'meta_'+fldId}
                        type="text"
                        value={value}
                        placeholder={placeholder}
                        onChange={(e)=>{
                            clearTimeout(this.fieldTimeout);
                            this.fieldTimeout = setTimeout( this.lookup_abr, 600 );
                            this.setState({currentValue: e.target.value});
                            onChange( e.target.value );
                        }}
                        autocomplete="off"
                        invalid={error}
                        className={fldClass}
                    />
                    <DropdownMenu>
                        {loadingAbn?(
                            <div className="text-center">
                        		<Spinner color="primary" />
                        	</div>
                        ):(
                            <>
                            {searchResults.map(res=>{
                                if( this.debug ) console.log('Looping ABR record: ',res);
                                const business = res.mainName ?? res.businessName ?? res.mainTradingName ?? res.mainName ?? res.legalName ?? null;
                                if( null == business ){
                                    //console.log('Failed to parse business: ',res);
                                    return null;
                                }
                                
                                const orgName = business.organisationName ?? business.fullName ?? '';
                                const orgNameUpper = orgName.toUpperCase();
                                //console.log('Organisation Name, ',orgName);
                                
                                const abn = this.formatAbn( res.ABN.identifierValue??'' );
                                return (
                                    <div
                                        key={res.ABN.identifierValue??''}
                                        onClick={e=>{
                                            if( this.debug ) console.log('Set ABN value', res);
                                            const otherValues = {
                                                'abn': abn
                                            };
                                            onChange( orgNameUpper, otherValues );
                                            this.setState({hasFocus:false});
                                        }}
                                    >
                                        {orgNameUpper} ({abn})
                                    </div>
                                );
                            })}
                            </>
                        )}
                    </DropdownMenu>
                </Dropdown>
            </>
        );
    }
}

BusinessField.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    placeholder: PropTypes.string,
    readonly: PropTypes.bool,
    error: PropTypes.bool,
    onChange: PropTypes.func
};

BusinessField.defaultProps = {
    fldId: null,
    value: null,
    placeholder: null,
    readonly: null,
    error: false,
    onChange: (newVal) => {console.log('Field value updated',newVal)}
}

export default BusinessField;
